import { SVGAttributes } from "react";

export function LinkedInLettersIcon({ ...props }: SVGAttributes<SVGSVGElement>) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Frame" clipPath="url(#clip0_6707_464)">
        <g id="Group">
          <path
            id="Vector"
            d="M0.75 4.03125H3.09806V11.25H0.75V4.03125ZM9.49388 4.11591C9.46894 4.10803 9.44531 4.0995 9.41906 4.09228C9.38755 4.08515 9.35581 4.07902 9.32391 4.07391C9.18526 4.04556 9.04411 4.03127 8.90259 4.03125C7.53366 4.03125 6.66544 5.02678 6.37931 5.41134V4.03125H4.03125V11.25H6.37931V7.3125C6.37931 7.3125 8.15381 4.84106 8.90259 6.65625V11.25H11.25V6.37866C11.249 5.86031 11.0761 5.35694 10.7583 4.94745C10.4405 4.53795 9.99576 4.24549 9.49388 4.11591Z"
            fill="#4B4E59"
          />
          <path
            id="Vector_2"
            d="M1.89844 3.04688C2.5327 3.04688 3.04688 2.5327 3.04688 1.89844C3.04688 1.26417 2.5327 0.75 1.89844 0.75C1.26417 0.75 0.75 1.26417 0.75 1.89844C0.75 2.5327 1.26417 3.04688 1.89844 3.04688Z"
            fill="#4B4E59"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6707_464">
          <rect width="10.5" height="10.5" fill="white" transform="translate(0.75 0.75)" />
        </clipPath>
      </defs>
    </svg>
  );
}
